import React from 'react';
import PropTypes from 'prop-types';
import { cloneObject } from '../../common/utils';

const Separator = ({ text, classNames = [], attributes: receivedAttributes = {} }) => {
  const attributes = cloneObject(receivedAttributes);

  if (text) {
    classNames.push('separator');
  }

  const finalClassName = classNames.join(' ');

  if (text) {
    return (
      <div className={finalClassName} {...attributes}>
        <span>{text}</span>
      </div>
    );
  }

  if (classNames.length > 0) {
    attributes.className = finalClassName;
  }

  return <hr {...attributes} />;
};

Separator.propTypes = {
  text: PropTypes.string,
  classNames: PropTypes.arrayOf(PropTypes.string),
  attributes: PropTypes.object
};

export default Separator;